import { Card, CardBody, Stack, Text } from '@lubehub/ui-web';

import { t } from '../copy';
import { OWNER_PHONE, SUPPORT_EMAIL } from '../legal/identity';
import { usePublicLocale } from '../locale';

export function SupportPage() {
  const { locale } = usePublicLocale();

  return (
    <Stack gap="lg">
      <Text as="h1" variant="display">
        {t(locale, 'support.title')}
      </Text>
      <Text variant="body">{t(locale, 'support.lead')}</Text>
      <Card>
        <CardBody>
          <Stack gap="sm">
            <Text variant="title">
              <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="support-email">
                {SUPPORT_EMAIL}
              </a>
            </Text>
            <Text variant="bodySm" tone="secondary">
              {t(locale, 'support.noChat')}
            </Text>
            <Text variant="bodySm" tone="secondary">
              {t(locale, 'support.phoneNote')}
            </Text>
            <Text variant="bodySm" tone="secondary">
              {OWNER_PHONE}
            </Text>
          </Stack>
        </CardBody>
      </Card>
    </Stack>
  );
}
